export const SET_PROPERTY_DATA = 'SET_PROPERTY_DATA';
export const POST_A_ADD = 'POST_A_ADD';
export const VALIDATE_PROPERTY_TITLE = 'VALIDATE_PROPERTY_TITLE'
export const SET_PROPERTY_STEP2_DATA = 'SET_PROPERTY_STEP2_DATA'

